import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import ErrorBoundary from './components/ErrorBoundary';
import { validateClientStartup } from './utils/startupValidator';
import './index.css';

// Run client startup health checks
validateClientStartup().then(report => {
  const failed = report.filter(r => !r.ok);
  if (failed.length > 0) {
    console.warn('[Startup] Some startup checks failed:', failed);
  } else {
    console.log('[Startup] All client modules validated successfully');
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);

